(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ganache", [], factory);
	else if(typeof exports === 'object')
		exports["ganache"] = factory();
	else
		root["ganache"] = factory();
})(global, function() {
return 